import { alpha } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";

// Type extensions for MUI Theme
declare module "@mui/material/styles" {
    interface TypeBackground {
        dark: string;
    }

    interface Palette {
        breakout: {
            main: string;
            light: string;
            dark: string;
            contrastText: string;
        };
    }

    interface PaletteOptions {
        breakout?: {
            main?: string;
            light?: string;
            dark?: string;
            contrastText?: string;
        };
    }

    interface Theme {
        layout: {
            mobile: {
                menu: {
                    drawer: {
                        width: number | string;
                    }
                }
            }
        };
    }

    // allow configuration using `createTheme`
    interface ThemeOptions {
        layout?: {
            mobile?: {
                menu?: {
                    drawer?: {
                        width?: number | string;
                    }
                }
            }
        };
    }
}

declare module '@mui/material/IconButton' {
    interface IconButtonPropsColorOverrides {
        breakout: true;
    }
}

declare module '@mui/material/Button' {
    interface ButtonPropsVariantOverrides {
        'breakout': true;
    }

    interface ButtonPropsColorOverrides {
        breakout: true;
    }
}

declare module '@mui/material/Badge' {
    interface BadgePropsColorOverrides {
        breakout: true;
    }
}

// Custom style objects
export const createSignatureBorderStyle = () => ({
    borderTopLeftRadius: 2,
    borderBottomRightRadius: 2,
    borderBottomLeftRadius: 16,
    borderTopRightRadius: 16,
});

export const createSignatureBorderStyleButtons = () => ({
    borderTopLeftRadius: 2,
    borderBottomRightRadius: 2,
    borderBottomLeftRadius: 8,
    borderTopRightRadius: 8,
});

export const createBreakoutStyle = (theme: Theme) => ({
    border: `2px solid ${theme.palette.breakout.main}`,
    backgroundColor: alpha(theme.palette.background.default, .75),
    '&:hover': {
        border: `2px solid ${theme.palette.breakout.light}`,
        backgroundColor: alpha(theme.palette.background.paper, .75),
    },
    '&.Mui-disabled': {
        border: `2px solid ${theme.palette.action.disabled}`,
        backgroundColor: alpha(theme.palette.background.default, 0.5),
    },
});

export const createGlassEffect = (theme: Theme) => {
    const blurLevel = 10;
    return {
        // color: theme.palette.mode === 'light' ? '#333333' : '#fff',
        backdropFilter: `blur(${blurLevel}px)`,
        WebkitBackdropFilter: `blur(${blurLevel}px)`,
        backgroundColor: `${alpha(theme.palette.background.paper, .5)}`,
        borderColor: alpha(theme.palette.primary.main, 0.5),
        borderStyle: 'solid',
        borderWidth: '1px',
        boxShadow: `0 4px 8px ${alpha(
            theme.palette.common.black, 
            theme.palette.mode === 'light' ? 0.3 : 0.5
        )}`,
    }
};
